import { createTheme } from "@mui/material";

// just to reuse them in theme
const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
};

export const theme = {
  ...breakpoints,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          fontWeight: 600,
        },
      },
    },
  },
  typography: {
    fontFamily: ['"Public Sans"', "Roboto", '"Helvetica"', "Arial", "sans-serif"].join(","),
    fontWeight: "300",
    lineHeight: "1.5em",
  },
};

export const lightTheme = createTheme({
  ...theme,
  palette: {
    background: {
      default: "#FCFAF5",
    },
    text: {
      primary: "#333333",
    },
    common: {
      black: "#333333",
    },
    default: {
      main: "#03102b",
      contrastText: "#ffffff",
    },
    primary: {
      contrastText: "#ffffff",
      main: "#B41C67",
      shiawaColor: "#39d88f",
      inProgress: "#FFBF1E",
    },
    secondary: {
      main: "#FF8942",
      shiawaColor: "#619ff9",
    },
    success: {
      main: "#3CC261",
      contrastText: "#ffffff",
    },
    delete: {
      main: "#f44336",
    },
  },
  components: {
    ...theme.components,
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 30px #FFFFFF inset !important",
          },
        },
      },
    },
  },
});
